export interface VideoItem {
  id: string;
  title: string;
  cover: string;
  duration: string;
  views: number;
  category: string;
  categoryName: string;
  description: string;
  publishDate: string;
  tags: string[];
}

export const videos: VideoItem[] = [
  {
    id: 'v001',
    title: '2026夏季最火搞笑合集：笑到停不下来的神操作',
    cover: 'https://readdy.ai/api/search-image?query=A%20vibrant%20and%20colorful%20video%20thumbnail%20showing%20a%20funny%20comedy%20scene%20with%20people%20laughing%20and%20colorful%20graphic%20elements%2C%20bright%20summer%20vibes%2C%20playful%20and%20energetic%20mood%2C%20clean%20composition%20with%20bold%20text%20area%2C%20modern%20YouTube-style%20thumbnail%20design%2C%20warm%20lighting&width=800&height=450&seq=video-cover-001&orientation=landscape',
    duration: '15:32',
    views: 1285000,
    category: 'xigua',
    categoryName: '西瓜视频',
    description: '精选2026年夏季全网最搞笑的精彩片段，包含搞笑失误、萌宠趣事、街头恶搞等爆笑内容，让你一次笑个够！',
    publishDate: '2026-07-28',
    tags: ['搞笑', '合集', '娱乐', '夏日'],
  },
  {
    id: 'v002',
    title: '零基础学广场舞《最炫民族风》完整教学版',
    cover: 'https://readdy.ai/api/search-image?query=A%20group%20of%20elderly%20people%20dancing%20square%20dance%20in%20a%20park%20with%20bright%20sunlight%2C%20energetic%20poses%2C%20colorful%20dance%20costumes%2C%20green%20trees%20and%20blue%20sky%20background%2C%20cheerful%20atmosphere%2C%20warm%20and%20inviting%20visual%20style&width=800&height=450&seq=video-cover-002&orientation=landscape',
    duration: '28:45',
    views: 895000,
    category: 'tangdou',
    categoryName: '糖豆视频',
    description: '专业舞蹈老师手把手教学，分解动作详解，从入门到熟练只需一节课。适合所有年龄段，零基础也能学会！',
    publishDate: '2026-07-25',
    tags: ['广场舞', '教学', '健身', '中老年'],
  },
  {
    id: 'v003',
    title: '2026年AI人工智能最新发展趋势深度解读',
    cover: 'https://readdy.ai/api/search-image?query=A%20futuristic%20technology%20scene%20with%20glowing%20circuit%20board%20patterns%2C%20AI%20neural%20network%20visualization%2C%20dark%20blue%20and%20cyan%20tones%2C%20modern%20tech%20aesthetic%2C%20clean%20and%20professional%20layout%2C%20digital%20innovation%20concept&width=800&height=450&seq=video-cover-003&orientation=landscape',
    duration: '42:18',
    views: 756000,
    category: 'xiaolan',
    categoryName: '小蓝视频',
    description: '深度剖析2026年AI行业最新动态，涵盖大模型发展、AI应用落地、行业变革等热门话题，科技爱好者必看。',
    publishDate: '2026-07-30',
    tags: ['AI', '科技', '趋势', '深度解读'],
  },
  {
    id: 'v004',
    title: '《快乐大本营2026》第七期：当红明星爆笑挑战',
    cover: 'https://readdy.ai/api/search-image?query=A%20bright%20and%20colorful%20variety%20show%20stage%20with%20celebrities%20playing%20funny%20games%2C%20studio%20lighting%2C%20colorful%20stage%20design%2C%20entertaining%20atmosphere%2C%20professional%20TV%20production%20quality%2C%20vibrant%20and%20energetic%20mood&width=800&height=450&seq=video-cover-004&orientation=landscape',
    duration: '68:20',
    views: 2350000,
    category: 'mangguo',
    categoryName: '芒果视频',
    description: '本期邀请当红明星参与爆笑游戏挑战，精彩互动不断，笑料百出，不容错过的综艺盛宴！',
    publishDate: '2026-07-31',
    tags: ['综艺', '明星', '搞笑', '热门'],
  },
  {
    id: 'v005',
    title: '《长安十二时辰》全集：盛世之下的暗流涌动',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20from%20ancient%20Chinese%20dynasty%20drama%2C%20Tang%20Dynasty%20architecture%20with%20lanterns%2C%20mysterious%20atmosphere%2C%20warriors%20in%20traditional%20armor%2C%20cinematic%20lighting%2C%20epic%20historical%20drama%20aesthetic&width=800&height=450&seq=video-cover-005&orientation=landscape',
    duration: '45:00',
    views: 1890000,
    category: 'sigua',
    categoryName: '丝瓜视频',
    description: '豆瓣高分古装悬疑剧，改编自马伯庸同名小说。唐代长安城内，一场惊心动魄的阴谋正在展开。',
    publishDate: '2026-07-20',
    tags: ['古装', '悬疑', '热剧', '高分'],
  },
  {
    id: 'v006',
    title: '舌尖上的中国·第四季：云南秘境美食之旅',
    cover: 'https://readdy.ai/api/search-image?query=Beautiful%20Yunnan%20landscape%20with%20traditional%20Chinese%20food%20on%20a%20wooden%20table%2C%20steaming%20hot%20dishes%2C%20green%20mountains%20in%20background%2C%20natural%20lighting%2C%20rich%20textures%20and%20warm%20colors%2C%20food%20documentary%20cinematography%20style&width=800&height=450&seq=video-cover-006&orientation=landscape',
    duration: '52:10',
    views: 3210000,
    category: 'lanmei',
    categoryName: '蓝莓视频',
    description: '深入云南秘境，探寻少数民族独特美食文化。从过桥米线到野生菌火锅，带你领略云南美食的无穷魅力。',
    publishDate: '2026-07-15',
    tags: ['美食', '纪录片', '云南', '文化'],
  },
  {
    id: 'v007',
    title: '猫咪的100种奇怪睡姿，铲屎官笑哭了',
    cover: 'https://readdy.ai/api/search-image?query=A%20cute%20orange%20tabby%20cat%20sleeping%20in%20a%20funny%20twisted%20pose%20on%20a%20soft%20sofa%2C%20warm%20home%20interior%2C%20soft%20natural%20light%20through%20window%2C%20cozy%20and%20humorous%20vibe%2C%20high%20detail%20pet%20photography&width=800&height=450&seq=video-cover-007&orientation=landscape',
    duration: '08:45',
    views: 4560000,
    category: 'xigua',
    categoryName: '西瓜视频',
    description: '盘点家养猫咪各种不可思议的睡姿，从趴键盘到钻纸箱，每一帧都萌化你的心！',
    publishDate: '2026-07-29',
    tags: ['萌宠', '猫咪', '搞笑', '日常'],
  },
  {
    id: 'v008',
    title: '中老年瑜伽入门：30天改善腰腿酸痛',
    cover: 'https://readdy.ai/api/search-image?query=Elderly%20couple%20practicing%20gentle%20yoga%20in%20a%20bright%20sunlit%20room%2C%20peaceful%20expressions%2C%20plants%20and%20natural%20decor%2C%20soft%20warm%20lighting%2C%20healthy%20lifestyle%20aesthetic%2C%20calm%20and%20serene%20atmosphere&width=800&height=450&seq=video-cover-008&orientation=landscape',
    duration: '35:20',
    views: 678000,
    category: 'tangdou',
    categoryName: '糖豆视频',
    description: '专为中老年人设计的温和瑜伽课程，每天30分钟，有效缓解腰腿酸痛，提升身体柔韧度。',
    publishDate: '2026-07-22',
    tags: ['瑜伽', '养生', '中老年', '健康'],
  },
  {
    id: 'v009',
    title: 'Python全栈开发实战：从零构建个人博客系统',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20coding%20setup%20with%20laptop%20showing%20Python%20code%20on%20screen%2C%20clean%20desk%20with%20notebook%20and%20coffee%2C%20dark%20theme%20IDE%2C%20minimal%20workspace%2C%20professional%20developer%20environment%2C%20warm%20ambient%20lighting&width=800&height=450&seq=video-cover-009&orientation=landscape',
    duration: '120:00',
    views: 423000,
    category: 'xiaolan',
    categoryName: '小蓝视频',
    description: '保姆级Python全栈教程，手把手教你用Django + React搭建个人博客，包含部署上线全流程。',
    publishDate: '2026-07-18',
    tags: ['编程', 'Python', '教程', '全栈'],
  },
  {
    id: 'v010',
    title: '《密室大逃脱2026》第三期：废弃医院惊魂夜',
    cover: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20abandoned%20hospital%20corridor%20with%20flickering%20lights%2C%20mysterious%20escape%20room%20setting%2C%20suspenseful%20and%20tense%20atmosphere%2C%20cinematic%20horror%20lighting%20with%20green%20tones%2C%20professional%20production%20quality&width=800&height=450&seq=video-cover-010&orientation=landscape',
    duration: '75:40',
    views: 1870000,
    category: 'mangguo',
    categoryName: '芒果视频',
    description: '明星嘉宾被困废弃医院，需要在限定时间内破解谜题逃脱，悬疑刺激，全程高能！',
    publishDate: '2026-07-27',
    tags: ['密室逃脱', '悬疑', '综艺', '刺激'],
  },
  {
    id: 'v011',
    title: '《狂飙》未删减版：扫黑风云再起',
    cover: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20drama%20scene%20with%20police%20officers%20in%20a%20dark%20alley%2C%20dramatic%20lighting%2C%20rainy%20night%20atmosphere%2C%20cinematic%20composition%2C%20tense%20and%20powerful%20mood%2C%20professional%20TV%20drama%20aesthetic&width=800&height=450&seq=video-cover-011&orientation=landscape',
    duration: '48:00',
    views: 5670000,
    category: 'sigua',
    categoryName: '丝瓜视频',
    description: '年度现象级扫黑剧集，张译、张颂文联袂出演。黑白较量，正义与邪恶的终极对决。',
    publishDate: '2026-07-10',
    tags: ['扫黑', '犯罪', '热剧', '高分'],
  },
  {
    id: 'v012',
    title: '地球脉动·海洋篇：深蓝之下的未知世界',
    cover: 'https://readdy.ai/api/search-image?query=Stunning%20underwater%20ocean%20scene%20with%20colorful%20coral%20reef%20and%20exotic%20fish%2C%20deep%20blue%20water%2C%20sunlight%20rays%20penetrating%20from%20above%2C%20breathtaking%20nature%20documentary%20cinematography%2C%20crystal%20clear%20water&width=800&height=450&seq=video-cover-012&orientation=landscape',
    duration: '58:30',
    views: 2890000,
    category: 'lanmei',
    categoryName: '蓝莓视频',
    description: 'BBC级别纪录片制作，深入海洋最深处，探索人类从未见过的神秘生物和壮丽景观。',
    publishDate: '2026-07-08',
    tags: ['纪录片', '海洋', '自然', '探索'],
  },
  {
    id: 'v013',
    title: '街头美食挑战：100元吃遍成都夜市',
    cover: 'https://readdy.ai/api/search-image?query=Vibrant%20Chengdu%20night%20market%20street%20food%20scene%20with%20colorful%20stalls%2C%20steaming%20hot%20skewers%2C%20red%20lanterns%2C%20crowded%20lively%20atmosphere%2C%20warm%20evening%20lighting%2C%20authentic%20Chinese%20street%20food%20culture&width=800&height=450&seq=video-cover-013&orientation=landscape',
    duration: '18:25',
    views: 1920000,
    category: 'xigua',
    categoryName: '西瓜视频',
    description: '只用100元，带你吃遍成都最地道夜市美食。串串香、担担面、钵钵鸡，每一样都让你流口水！',
    publishDate: '2026-07-26',
    tags: ['美食', '街头', '成都', '挑战'],
  },
  {
    id: 'v014',
    title: '太极拳二十四式标准教程：强身健体每一天',
    cover: 'https://readdy.ai/api/search-image?query=Elderly%20master%20practicing%20Tai%20Chi%20in%20a%20peaceful%20Chinese%20garden%20at%20sunrise%2C%20flowing%20movements%2C%20traditional%20Chinese%20pavilion%20background%2C%20misty%20morning%20atmosphere%2C%20serene%20and%20harmonious%20composition&width=800&height=450&seq=video-cover-014&orientation=landscape',
    duration: '45:00',
    views: 534000,
    category: 'tangdou',
    categoryName: '糖豆视频',
    description: '国家武术教练标准示范，二十四式太极拳全套教学，适合初学者和中老年朋友日常练习。',
    publishDate: '2026-07-19',
    tags: ['太极拳', '养生', '教学', '健身'],
  },
  {
    id: 'v015',
    title: '量子计算入门：普通人也能听懂的量子力学',
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20quantum%20physics%20visualization%20with%20glowing%20particles%20and%20waves%2C%20dark%20background%20with%20blue%20and%20gold%20light%20patterns%2C%20scientific%20but%20artistic%20aesthetic%2C%20elegant%20and%20mind-bending%20composition&width=800&height=450&seq=video-cover-015&orientation=landscape',
    duration: '32:15',
    views: 312000,
    category: 'xiaolan',
    categoryName: '小蓝视频',
    description: '用最通俗的语言讲解量子计算基本原理，不需要任何物理基础，带你走进神奇的量子世界。',
    publishDate: '2026-07-16',
    tags: ['量子', '科普', '物理', '入门'],
  },
  {
    id: 'v016',
    title: '《歌手2026》巅峰对决：华语乐坛最强音',
    cover: 'https://readdy.ai/api/search-image?query=A%20grand%20music%20competition%20stage%20with%20spotlights%20and%20a%20singer%20performing%2C%20dramatic%20stage%20lighting%2C%20large%20LED%20screen%20background%2C%20enthusiastic%20audience%2C%20professional%20concert%20production%2C%20vibrant%20and%20powerful%20atmosphere&width=800&height=450&seq=video-cover-016&orientation=landscape',
    duration: '95:00',
    views: 3450000,
    category: 'mangguo',
    categoryName: '芒果视频',
    description: '顶级歌手同台竞技，华语乐坛最震撼的音乐盛宴。谁能摘得歌王桂冠？精彩不容错过！',
    publishDate: '2026-07-24',
    tags: ['音乐', '歌手', '竞技', '热门'],
  },
];

export function getVideosByCategory(slug: string): VideoItem[] {
  return videos.filter((v) => v.category === slug);
}

export function getVideoById(id: string): VideoItem | undefined {
  return videos.find((v) => v.id === id);
}

export function getRelatedVideos(id: string, limit: number = 4): VideoItem[] {
  const current = getVideoById(id);
  if (!current) return videos.slice(0, limit);
  return videos.filter((v) => v.category === current.category && v.id !== id).slice(0, limit);
}

export function getHotVideos(limit: number = 8): VideoItem[] {
  return [...videos].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getLatestVideos(limit: number = 8): VideoItem[] {
  return [...videos].sort((a, b) => b.publishDate.localeCompare(a.publishDate)).slice(0, limit);
}